import homeBooks from "../data/HomeBooks.json";
import React from "react";
import "../styles/Books.css"; // Make sure to create this CSS file
import { useState, useEffect } from "react";
const BookShowcase = () => {
  const [booksData, setBooks] = useState({ books: [] });
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      setBooks(homeBooks);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!booksData) return <p>Loading...</p>;

  if (error) return <p>Error: {error}</p>;
  if (!booksData) return <p>Loading...</p>;

  return (
    <section className="book-section">
      <div className="book-grid-wrapper">
        <h3>Books on NVS and Respiratory Care(available on Amazon)</h3>
        <div className="book-grid">
          {booksData.books.map((book, index) => (
            <div className="book-card" key={index}>
              <img src={book.image} alt={book.title} className="book-image" />
              <h3 className="book-title">{book.title}</h3>
              <p className="book-author">By {book.author}</p>
              <p className="book-isbn">ISBN: {book.ISBN}</p>

              {book.links && (
                <div className="book-links">
                  <p>
                    {book.links.paperback && (
                      <a
                        href={book.links.paperback}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Paperback
                      </a>
                    )}
                    {book.links.hardcover && (
                      <a
                        href={book.links.hardcover}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Hardcover
                      </a>
                    )}
                    {book.links.amazon_es && (
                      <a
                        href={book.links.amazon_es}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Amazon ES
                      </a>
                    )}
                    {book.links.amazon_com && (
                      <a
                        href={book.links.amazon_com}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Amazon US
                      </a>
                    )}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BookShowcase;
